import React from 'react';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import CheckInput from 'screens/components/basic/CheckInput';
import GenericTable from 'screens/components/advanced/GenericTable';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "ProductRanking";
const Header = (props) => (
    <CardSimple className="p-1">
        <div className="row mt-1">
            <div className="col-xs-12 col-sm-6">
                <p>Choose Base Store: (only one)</p>
                <GenericTable
                    className="table-inventory"
                    compName="baseStore"
                    tableHeaderClassName="table-products-header"
                    tableBodyClassName="table-products"
                    adjustForCheckbox={true}
                    displaySelectAll={false}
                    displayRowCheckbox={true}
                    enableSelectAll={false}
                    multiSelectable={false}
                    selectable={true}
                    stripedRows={true}
                    columns={[
                        { key: "store", label: "Base Store", visibleMode: "d-none-xs" }
                    ]}
                    rows={props.branchOptions.map((item) => {
                        return {
                            store: item.text,
                            id: item.value
                        };

                    })}
                />
            </div>
            <div className="col-xs-12 col-sm-6">
                <p>Choose Stores to Compare To: </p>
                <GenericTable
                    className="table-inventory"
                    compName="storeToCompare"
                    tableHeaderClassName="table-products-header"
                    tableBodyClassName="table-products"
                    adjustForCheckbox={true}
                    displaySelectAll={false}
                    displayRowCheckbox={true}
                    enableSelectAll={false}
                    multiSelectable={true}
                    selectable={true}
                    stripedRows={true}
                    columns={[
                        { key: "store", label: "Stores to Compare", visibleMode: "d-none-xs" }
                    ]}
                    rows={props.branchOptions.map((item) => {
                        return {
                            checkbox: <CheckInput />,
                            store: item.text,
                            id: item.value
                        };

                    })}
                />
                {

                }
            </div>
        </div>
        <div className="row">
            <div className="col-xs-6 col-sm-6 col-md-4">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.fromDate.name}
                    floatingLabelText={LOOKUP.report.common.fromDate.label + "*"}
                    hintText={LOOKUP.report.common.fromDate.label + "*"}
                    fullWidth={true}
                />
            </div>
            <div className="col-xs-6 col-sm-6 col-md-4">
                <DatePickerInput
                    name={componentName + LOOKUP.report.common.toDate.name}
                    floatingLabelText={LOOKUP.report.common.toDate.label}
                    hintText={LOOKUP.report.common.toDate.label}
                    fullWidth={true}
                />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
                <SelectInput
                    name={componentName + LOOKUP.report.common.categoryName}
                    fullWidth={true}
                    label={LOOKUP.report.common.categoty}
                    floatingLabelText={LOOKUP.report.common.categoty}
                    hintText={LOOKUP.report.common.categoty}
                    options={[{ text: 'All', value: 0 }].concat(props.productCategories)}
                    defaultValue="0"
                />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Button
                    type="IconInButton"
                    className="pull-right ml-1 btnNewBrandPOS"
                    name={componentName + LOOKUP.report.common.viewReport.name}
                    label={LOOKUP.report.common.viewReport.label}
                    icon={<VisibilityIcon />}
                    onTouchTap={props.showBody}
                />
            </div>
        </div>
    </CardSimple>
);

export default Header;